import React, { PureComponent } from 'react';

class GoogleLinkSimple extends PureComponent {
    constructor(props) {
        super(props);
        this.props = props;
    }

    render() {
        const { searchField } = this.props;
        return (
            <a
                className="link"
                style={{ cursor: 'pointer', width: '25px' }}
                href={`https://www.google.com/search?q=${searchField}`}
                target="external"
                rel="noopener noreferrer nofollow"
            >
                &nbsp;G
            </a>
        );
    }
}

export default GoogleLinkSimple;
